import { render, staticRenderFns } from "./numberCase.vue?vue&type=template&id=3ebcd676&scoped=true"
import script from "./numberCase.vue?vue&type=script&lang=js"
export * from "./numberCase.vue?vue&type=script&lang=js"
import style0 from "./numberCase.vue?vue&type=style&index=0&id=3ebcd676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebcd676",
  null
  
)

export default component.exports